/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { DAIPermissionCodename } from '@/graphql'

import useLoggedInUser from './useLoggedInUser'

export const usePermissions = () => {
  const { user } = useLoggedInUser('cache-first')
  const userPermissions = user?.groups.flatMap(group => group.permissions) || []
  return {
    roles: user?.groups.map(group => group.name),
    permissions: Object.keys(DAIPermissionCodename)?.reduce(
      (acc, permission) => {
        if (userPermissions.some(p => p.codename === permission)) {
          return { ...acc, [permission]: true }
        }
        return { ...acc, [permission]: false }
      },
      {} as { [key in DAIPermissionCodename]: boolean },
    ),
  }
}
